import Guard from "vue-router-multiguard";
import { Middlewares } from "@/app/shared/services/app-router/middlewares";

export default [
    {
        path: "/users",
        name: "UserList",
        component: () => import("./views/users"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/admin-login",
        name: "AdminLogin",
        component: () => import("./views/login"),
    },
];
